import * as Features from '../../../../../../../shared/Features';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { IOrderRow } from '../../../Entities';
import { ImageEditorPhotoStatus } from '../queries/use-query-photo-status';

export function canViewUneditedImages(
    user: AuthenticatedUser,
    photoStatus: ImageEditorPhotoStatus
): boolean {
    return (
        Features.hasFeature(Features.ViewUneditedImages, user) &&
        photoStatus.photographerIsEditor === false
    );
}

export function countImages(orderRows: IOrderRow[]): number {
    return orderRows.reduce((total, orderRow) => total + orderRow.thumbnails.length, 0);
}
